import type React from 'react';

import { MenuItem } from '@mui/material';
import Menu from '@mui/material/Menu';

import { Clock } from '@shared/assets';
import { useMuiMenu } from '@shared/hooks';
import { TextInput } from '@shared/ui';

import { useTimezoneLoader, useTz } from './model';
import * as st from './styles.module.scss';

export const TimezoneSelect: React.FC = () => {
	const { anchorEl, isOpen, onOpen, onClose } = useMuiMenu();
	const { onSearch, search, geo } = useTimezoneLoader();

	const { tz, setTimezone } = useTz();

	return (
		<>
			<button className={st.btn} id="tz-button" onClick={onOpen}>
				<Clock />
				<div className={st.btn__text}>{tz}</div>
			</button>
			<Menu
				id={'tz-menu'}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				open={isOpen}
				onClose={onClose}
				MenuListProps={{
					'aria-labelledby': 'tz-button',
				}}
			>
				<MenuItem>
					<TextInput type="text" value={search} onChange={onSearch} fullWidth />
				</MenuItem>
				{geo && (
					<MenuItem>
						<button
							onClick={() => {
								setTimezone(geo.timezone);
								onClose();
							}}
						>{`${geo?.geo.country}, ${geo?.geo.state}`}</button>
					</MenuItem>
				)}
			</Menu>
		</>
	);
};
